export const canPullProduct = () => () => {
    return function (node) {
        if (! this.permission.has('write')) {
            this.logger.error('没有权限', [node])
            return false
        }

        const {bizNodeType, pkid} = node.data

        if (! pkid) {
            this.logger.error('只有制品才能刷新', [node])
            return false
        }

        const bn = this.BizNode[bizNodeType]

        if (! bn.pull) {
            const name = bn.typeName(this, node.parent)
            this.logger.error(`${name}不支持刷新`, [node])
            return false
        }

        return bn.canWriteData(this, node)
    }
}

export const pullProduct = () => () => {
    return function (nodes) {
        return Promise.allSettled(
            [...nodes].map(
                async (node) => {
                    try {
                        const _n = this.nodeProxy(node)
                        await _n.pull()
                        this.logger.info('刷新制品成功', [node])
                        this.selectNodes([node])
                    }
                    catch (err) {
                        this.logger.error(
                            `刷新制品失败: ${err.message}`,
                            [node]
                        )

                        err.nodes = [node]
                        throw err
                    }
                }
            )
        )
    }
}
